import { ThemeConfig } from "antd"

export const theme: ThemeConfig = {
  token: {
    // Brand colors — lighter navy blue (Taste_Skill design system v3)
    colorPrimary: "#2E5A88",
    colorLink: "#2E5A88",
    colorError: "#E7695F",
    colorSuccess: "#52CB67",

    // Linear border radius scale (comfortable = 6px)
    borderRadius: 6,
    borderRadiusLG: 8,
    borderRadiusSM: 4,
    borderRadiusXS: 2,

    // Typography — Be Vietnam Pro (mockup font; VN-optimized), Inter fallback
    fontFamily: "'Be Vietnam Pro', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    // Base body font size — reconciled with HUMAN_02 D12 (@font-size-body: 14px).
    fontSize: 14,
    fontSizeSM: 12,
    fontSizeLG: 16,
    lineHeight: 1.5715,

    // Surfaces & colors
    colorBgContainer: "#ffffff",
    colorBgLayout: "#F2F4F8",
    colorBgElevated: "#ffffff",
    colorBgSpotlight: "#f7f8fa",

    // Text hierarchy (Linear light mode)
    colorText: "#1a1a1a",
    colorTextSecondary: "#4B5C71",
    colorTextTertiary: "#8a8f98",
    colorTextQuaternary: "#b0b7c3",

    // Borders (Linear light mode)
    colorBorder: "#d0d6e0",
    colorBorderSecondary: "#e6e6e6",

    // Shadows (Linear elevation system)
    boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
    boxShadowSecondary: "0 4px 6px rgba(0,0,0,0.05), 0 2px 4px rgba(0,0,0,0.04)",

    // Spacing
    padding: 12,
    paddingSM: 10,
    paddingLG: 24,
    margin: 16,
    marginSM: 12,
    marginLG: 24,
  },
  components: {
    // Table: clean, Linear-style header (design-system tokens)
    Table: {
      headerBg: "#f7f8fa",
      headerColor: "#4B5C71",
      headerSortActiveBg: "#E7ECF2",
      rowHoverBg: "#fafbfc",
      borderColor: "#f2f3f6",
      borderRadius: 8,
      cellPaddingBlock: 5,
      cellPaddingInline: 10,
      fontSize: 12,
    },
    // Card: minimal shadow, clean
    Card: {
      borderRadius: 8,
      boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
    },
    // Button: Linear comfortable radius (design-system: weight 600)
    Button: {
      borderRadius: 6,
      defaultBorderColor: "#d0d6e0",
      defaultColor: "#4B5C71",
      fontWeight: 600,
      colorPrimaryHover: "#4A7AAF",   // ~10% lighter than primary
      colorPrimaryActive: "#24527D",  // ~5% darker than primary
    },
    // Inputs — form-control text standardized to 12px (@font-size-base).
    // `colorTextDisabled` mirror @input-disabled-text: giá trị trong field disabled
    // phải đọc được, không nhạt ngang placeholder. CHỈ override ở cấp component —
    // Button/Menu disabled vẫn giữ màu xám mặc định để không mất dấu hiệu disabled.
    Input: {
      borderRadius: 6,
      colorBorder: "#d0d6e0",
      fontSize: 12,
      colorTextDisabled: "#1a1a1a",
    },
    // Form labels — design-system (label #4B5C71 / 13px)
    Form: {
      labelColor: "#4B5C71",
      labelFontSize: 12,
    },
    Select: {
      borderRadius: 6,
      fontSize: 12,
      colorTextDisabled: "#1a1a1a",
    },
    InputNumber: {
      borderRadius: 6,
      fontSize: 12,
      colorTextDisabled: "#1a1a1a",
    },
    DatePicker: {
      borderRadius: 6,
      fontSize: 12,
      colorTextDisabled: "#1a1a1a",
    },
    // Other form controls (Select/Input-based) — standardized to 12px
    // (AutoComplete reuses Select internally, covered by Select.fontSize above)
    Cascader: {
      fontSize: 12,
      colorTextDisabled: "#1a1a1a",
    },
    TreeSelect: {
      fontSize: 12,
      colorTextDisabled: "#1a1a1a",
    },
    Mentions: {
      fontSize: 12,
      colorTextDisabled: "#1a1a1a",
    },
    // Modal: Linear dialog shadow
    Modal: {
      borderRadius: 12,
      boxShadow: "0 8px 2px rgba(0,0,0,0), 0 5px 2px rgba(0,0,0,0.01), 0 3px 2px rgba(0,0,0,0.04), 0 1px 1px rgba(0,0,0,0.07), 0 0 1px rgba(0,0,0,0.08)",
    },
    // Dropdown & Menu
    Dropdown: {
      borderRadius: 8,
      boxShadow: "0 4px 6px rgba(0,0,0,0.05), 0 2px 4px rgba(0,0,0,0.04)",
    },
    Menu: {
      borderRadius: 6,
      itemBorderRadius: 4,
    },
    // Tag: pill style (design-system neutral)
    Tag: {
      borderRadius: 4,
      defaultBg: "#EEF0F3",
      defaultColor: "#4B5C71",
    },
    // Tooltip
    Tooltip: {
      borderRadius: 6,
      colorBgSpotlight: "#2E5A88",
      colorTextLightSolid: "#ffffff",
    },
    // Tabs
    Tabs: {
      inkBarColor: "#2E5A88",
      itemActiveColor: "#2E5A88",
      itemHoverColor: "#2E5A88",
    },
  },
}
